<template>
  <div>
    <div class="h-32 bg-forestree-green w-full"></div>

    <div class="md:flex md:flex-wrap md:justify-center mb-6">
      <!-- Loading section -->
      <div v-if="loading" class="w-full md:w-1/2 my-8 text-center">
        <img src="/loading.gif" width="60" class="mx-auto" />
        <h3 class="text-lg text-slate-500 leading-none mb-3">Loading...</h3>
      </div>

      <!-- Content when not loading -->
      <div v-if="!loading" class="w-full md:w-1/2 my-8 text-center">
        <div class="text-2xl text-slate-700 leading-none mb-3">
          You are user linked to multiple Organisations
        </div>
        <div class="text-lg text-slate-500 leading-none mb-3">
          Please select the one you would like to use
        </div>
      </div>

      <!-- Display all clients -->
      <div
        v-for="(client, index) in allClients"
        :key="index"
        @click.prevent="chooseClient(client.id)"
        class="w-full md:w-1/2 px-2 mx-2 md:mx-8 mb-4 rounded-lg bg-white hover:bg-slate-100 shadow-lg my-6 cursor-pointer"
      >
        <div class="all-rounded mb-2 p-6">
          <div class="flex flex-wrap md:flex-no-wrap justify-between">
            <div class="text-sm">
              <p class="text-blue-800 text-2xl leading-none">
                {{ client.name }}
              </p>
              <p class="text-slate-600 py-2 text-lg leading-none">
                {{ client.state }}
              </p>
              <span
                :class="
                  client.is_contractor
                    ? 'bg-blue-200 text-blue-700 font-semibold'
                    : 'bg-orange-200 text-orange-700'
                "
                class="text-xs rounded-full px-3 py-1"
              >
                {{ client.is_contractor ? "Contractor" : "User" }}
              </span>
            </div>
            <div>
              <span
                class="inline-block bg-slate-100 rounded-full px-4 py-2 font-semibold text-slate-700 mx-0 md:mx-3 my-1"
              >
                Open >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import moment from "moment";
import axios from "axios";

const today = moment().format("dddd Do MMM YYYY");
const allClients = ref([]);
const clients = ref([]);
const loading = ref(false);

const chooseClient = (cID) => {
  loading.value = true;
  axios
    .post("/api/clients/session", { cid: cID })
    .then(() => {
      window.location.href = "/home";
    })
    .catch((error) => {
      console.log(error);
    });
};

const getSession = () => {
  loading.value = true;
  axios
    .get("/api/clients")
    .then((response) => {
      clients.value = response.data.clients;
      allClients.value = response.data.allClients;
      loading.value = false;
    })
    .catch((error) => {
      console.log(error);
    });
};

// Fetch session data on component mount
onMounted(() => {
  getSession();
});
</script>
